import NotificationSettingList from '@components/NotificationSettingList'
import Page from '@components/Page/Page'
import { SettingKey } from '@models/Setting'
import { useAppDispatch } from '@store/hooks'
import { getSettings } from '@store/SettingReducer'
import { Permission } from '@utils/permissions'
import { useEffect } from 'react'
import { bookingNotificationItems } from './bookingNotificationItems'

const BookingNotificationsPage = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      getSettings([
        SettingKey.NOTFICATION_RESERVATION_PLACED_ENABLED,
        SettingKey.NOTFICATION_RESERVATION_CONFIRMATION_ENABLED,
        SettingKey.NOTFICATION_RESERVATION_UPDATED_ENABLED,
        SettingKey.NOTFICATION_RESERVATION_CANCELLED_ENABLED,
        SettingKey.NOTFICATION_RESERVATION_NO_SHOW_ENABLED,
      ])
    )
  }, [])

  return (
    <Page permissions={Permission.manageSettingsBookingSettings}>
      <NotificationSettingList
        items={bookingNotificationItems}
        title="Booking notifications"
      />
    </Page>
  )
}

export default BookingNotificationsPage
